import React from "react";
import { Button, Nav, Navbar } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import "./MyNavbar.css";
import fb from "../../../facebook.png";
import linked from "../../../linkedin.png";
import github from "../../../github-logo.png";

const MyNavbar = () => {
  return (
    <Navbar sticky="top" collapseOnSelect expand="md" className="myNavbar">
      <Navbar.Brand as={NavLink} to="/">
        {" "}
        <h3 style={{ color: "#FFFF00" }}> AH </h3>
      </Navbar.Brand>
      <Navbar.Toggle
        style={{ backgroundColor: "white" }}
        aria-controls="responsive-navbar-nav"
      />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ml-auto mr-auto">
          <NavLink
            activeStyle={{ borderBottom: "3px solid red" }}
            className="mx-3 text-decoration-none"
            exact
            to="/portfolio"
          >
            <span className="text-white">Portfolio</span>
          </NavLink>
          <NavLink
            activeStyle={{ borderBottom: "3px solid red" }}
            className="mx-3 text-decoration-none"
            to="/project"
          >
            <span className="text-white">Project</span>
          </NavLink>
          <NavLink
            activeStyle={{ borderBottom: "3px solid red" }}
            className="mx-3 text-decoration-none"
            to="/blog"
          >
            <span className="text-white">Blog</span>
          </NavLink>
          <NavLink
            activeStyle={{ borderBottom: "3px solid red" }}
            className="mx-3 text-decoration-none"
            to="/about"
          >
            <span className="text-white">About</span>{" "}
          </NavLink>
          <NavLink
            activeStyle={{ borderBottom: "3px solid red" }}
            className="mx-3 text-decoration-none"
            to="/contact"
          >
            <span className="text-white">Contact</span>
          </NavLink>
          <a
            className="mx-3"
            target="_blank"
            href="https://drive.google.com/file/d/1oDHsd3JF7ZfaPa1P2UgblsOreT4vwvwW/view?usp=sharing"
          >
            <Button variant="danger">Resume</Button>
          </a>
        </Nav>
        <Nav className="">
          <a
            className="mx-2 social"
            target="_blank"
            href="https://github.com/abuhorainhero"
          >
            <img
              src={github}
              alt=""
              className="img-fluid rounded-circle githubLink"
            />
          </a>
          <a
            className="mx-2 social"
            target="_blank"
            href="https://www.facebook.com/mdabuhorain"
          >
            <img
              src={fb}
              alt=""
              className="img-fluid rounded-circle facebookLink"
            />
          </a>
          <a
            className="mx-2 social"
            target="_blank"
            href="http://www.linkedin.com/in/abuhorain"
          >
            <img
              src={linked}
              alt=""
              className="img-fluid rounded-circle linkedInLink"
            />
          </a>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default MyNavbar;
